import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getGamerInformation = (params) => {
    return axios.get(`${backendHost}/api/admin/gamer/information`, {params});
};

export {
    getGamerInformation
}